import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SMS_PAYMENTS } from '@/api/endpoints';
import { useRefreshUser } from '@/hooks/useRefreshUser';
import { ErrorMessage, logRequestError } from '@/utils/errors';

interface Params {
  onSuccess: () => void;
  onError: () => void;
}

export const useSubscribeToSms = ({ onSuccess, onError }: Params) => {
  const refreshUser = useRefreshUser();

  const { mutate: subscribeToSms, isPending } = useMutation({
    mutationFn: async (isRecurringSubscriber: boolean) => {
      await apiClient.post(API_SMS_PAYMENTS, { isRecurringSubscriber });
      await refreshUser();
    },
    onSuccess: () => {
      onSuccess();
    },
    onError: (error) => {
      logRequestError(ErrorMessage.SubscribeToSms, error);
      onError();
    },
  });

  return { subscribeToSms, isPending };
};
